import codIcon from '../../../assets/codIcon.png'
import clientIcon from '../../../assets/clientIcon.png'
import typeServiceIcon from '../../../assets/typeServiceIcon.png'
import providerIcon from '../../../assets/providerIcon.png'

interface CriteriaItem {
    id: number
    code: string
}

interface MultiSelectCriteriaDetailProps {
    id: number
    name: string
    valueKey:
        | 'distribution_provider'
        | 'service_code'
        | 'service_types'
        | 'clients'
    criteria_list: CriteriaItem[]
}

export const MultiSelectCriteriaDetail = ({
    name,
    valueKey,
    criteria_list,
}: MultiSelectCriteriaDetailProps) => {
    const criteriaIcons = {
        distribution_provider: providerIcon,
        service_code: codIcon,
        service_types: typeServiceIcon,
        clients: clientIcon,
    }

    const criteriaTitles = {
        distribution_provider: 'Proveedores de distribución',
        service_code: 'Códigos de servicio',
        service_types: 'Tipos de servicio',
        clients: 'Clientes',
    }

    return (
        <div className="flex items-center mb-2">
            <img src={criteriaIcons[valueKey]} alt={`${name} icon`} />
            <h3 className="text-[#141A1F] text-[14px] font-normal ml-2">
                {criteriaTitles[valueKey]}:
            </h3>

            <div className="ml-2">
                <ul className=" flex gap-2 items-center">
                    {criteria_list.length > 0 ? (
                        criteria_list.map((item) => (
                            <li
                                key={item.id}
                                className="flex items-center text-[#3E5060] text-[14px] font-normal"
                            >
                                <span className="bg-[#F1F5F9] rounded px-2 py-1 text-sm">
                                    {item.code}
                                </span>
                            </li>
                        ))
                    ) : (
                        <p className="text-gray-400 text-sm">
                            No hay elementos seleccionados
                        </p>
                    )}
                </ul>
            </div>
        </div>
    )
}
